const collectionSettingsData = [
  {
    label: 'Learners’ authentication',
    icon: 'hugeicons:access',
    path: 'learner-authentication',
  },
  {
    label: 'Custom domain',
    icon: 'lsicon:earth-outline',
    path: 'custom-domain',
  },
  {
    label: 'Certification',
    icon: 'ph:certificate',
    path: 'certification',
  },
  {
    label: 'General',
    icon: 'solar:settings-outline',
    path: 'general',
  },
  {
    label: 'White labeling',
    icon: 'proicons:mail',
    path: 'white-labeling',
  },
]

export default collectionSettingsData
